import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { QueryConfig } from '@nohara-dxdev/react-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { SystemWithSubsystems } from '@/types/api';

export const getSystems = async (
  orgId: string,
  projectId: string,
): Promise<SystemWithSubsystems[]> => {
  const { data } = await api.get<unknown, ApiResponse<SystemWithSubsystems[]>>(
    `/orgs/${orgId}/projects/${projectId}/systems`,
  );
  return data;
};

export const getSystemsQueryKey = (orgId?: string, projectId?: string) => {
  const queryKey = ['systems'];
  if (orgId) queryKey.push('org', orgId);
  if (projectId) queryKey.push('project', projectId);
  return queryKey;
};

export const getSystemsQueryOptions = (orgId: string, projectId: string) => {
  return queryOptions({
    queryKey: getSystemsQueryKey(orgId, projectId),
    queryFn: () => getSystems(orgId, projectId),
    enabled: !!orgId && !!projectId,
  });
};

interface UseSystemsOptions {
  queryConfig?: QueryConfig<typeof getSystemsQueryOptions>;
}

export const useSystems = ({ queryConfig }: UseSystemsOptions = {}) => {
  const { orgId, projectId } = useScopeIds();
  return useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ...getSystemsQueryOptions(orgId!, projectId!),
    ...queryConfig,
  });
};
